<template>
  <div>
    <v-toolbar class="my-md-auto" elevation="0"  >
      <v-toolbar-title v-if="item" class="toolbartitle_50" >
        <h1><v-icon large>mdi-file-cad</v-icon>{{$t('designfile.designfiletypes')}}</h1>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          color=""
          class="ml-sm-2"
          @click="resetForm"
        >
          {{ $t('global.reset')}}
        </v-btn>
        <v-btn
          :loading="isLoading"
          class="ml-sm-2"
          color="primary"
          @click="onSendProdFileForm"
        >
          {{ $t('global.submit')}}
        </v-btn>
      </div>
    </v-toolbar>

    <DesignFileTypeForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import DesignFileTypeForm from '../../components/designfiletype/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'DesignFileType';

const { mapFields } = createHelpers({
  getterType: 'designfiletype/getField',
  mutationType: 'designfiletype/updateField'
});

export default {
  name: 'DesignFileTypeCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Loading,
    DesignFileTypeForm
  },
  data() {
    return {
      item: {
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'uploaded','created', 'violations']),
  },
  methods: {
    ...mapActions('designfiletype', ['create','upload', 'reset']),

    onSendProdFileForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    }
  }
};
</script>
